module.exports = __webpack_public_path__ + "static/5-dea31efe30424627cdd5b934f8bcf433.jpg";